import { Component } from '@angular/core';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';

@Component({
  selector: 'app-suprimentos-home',
  imports: [ListaFuncionalidadeComponent, HeaderComponent],
  templateUrl: './suprimentos-home.component.html',
  styleUrl: './suprimentos-home.component.css',
})
export class SuprimentosHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Suprimentos;
    this.funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_ControleEstoque;
  }
}
